module.exports = __webpack_public_path__ + "static/media/table_column_reorder_sample_2.af8b63e9.png";